<div class="visualizacao-painel">
  <div class="visualizacao-acoes">
    <button mat-stroked-button class="btn-atualizar" (click)="atualizar()">
      <i class="pi pi-refresh"></i> Atualizar
    </button>
    <button mat-stroked-button class="btn-baixar-pdf" (click)="baixarPdf()" [disabled]="baixandoPdf">
      <i class="pi pi-file-pdf"></i> {{ baixandoPdf ? 'Gerando PDF...' : 'Baixar PDF' }}
    </button>
  </div>
  <div class="visualizacao-iframe-wrapper">
    <iframe class="visualizacao-iframe" [srcdoc]="htmlVisualizado" sandbox="allow-same-origin"
      [style.height.px]="iframeHeightPx" (load)="onIframeLoad($event)"></iframe>
  </div>
</div>
